//updated

import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from '@swimlane/ngx-datatable';
import { Workflow, WorkflowType } from 'src/app/models';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, TimeoutError } from 'rxjs';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { DropdownOption } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import { ItemSearchOptionField, ItemSearchOptionFieldOption } from 'src/app/components/filter-list/models/filterClasses';
import { ConditionOperator, ConditionSource, ConditionValue, OperatorTypes } from 'src/app/components/system/condition-builder/condition-builder.model';
import { DataSetField, FilterConfig, ReportDataSetFieldDataType, WorkflowFilter } from 'src/app/models/custom-report';
import { AggregatedDataSetFieldTypes, AggregatedDataSetRowTypes, DataSet, DataSetAggregateCalculatedField, DataSetAggregateField, DataSetAggregateGroupedCriteriaRow, DataSetAggregateKeyField, DataSetAggregateRow, DataSetAggregateStaticField, DataSetAggregrateGroupingRow, ReportDataSetOrder, SortDirection, WorkflowApplicationReportDataSet } from 'src/app/models/report-data-set';
import { SecurityService, Utilities, WorkflowContextService, WorkflowService } from 'src/app/services';
import { svgs } from 'src/assets/export.assets';
import { TableColumn as CommonTableColumn } from 'src/app/components/common/common-table/common-table.component';
import { FilterBuilderFilter, FilterBuilderFilterFlat, FilterBuilderParam } from 'src/app/models/filter-builder';
import { DateDataEntity, FreeFormTextDataEntity } from 'src/app/models/data-entities';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'wm-data-set-information',
  templateUrl: './data-set-information.component.html',
  styleUrls: ['./data-set-information.component.css'],
  standalone: false
})
export class DataSetInformationComponent implements OnInit {
  ds: DataSet;

  @Input() dataSetId?: string;
  @Input() dataSet: WorkflowApplicationReportDataSet;
  @Input() form!: UntypedFormGroup;
  @Input() staticFilters?: ItemSearchOptionField[];
  conditionSources: ConditionSource[];
  outputFormulaConditionSources: ConditionSource[];
  @Output() dataSetSaved = new EventEmitter<string>();
  filterInputForm: UntypedFormGroup;
  allowFiltering = false;

  ALL_WORKFLOWS_ID = Utilities.EMPTY_GUID
  workflowEntities: { [key: string]: string[] };
  canPublish = false;

  mappingForm: UntypedFormGroup;
  isSystemAdmin: boolean;
  availbleWorkflows: Workflow[];
  availableWorkflows: Workflow[] = [];
  @Input() getAvailableWorkflows?: () => Observable<Workflow[]>;

  isDeveloper: boolean;
  @Input() dataSetName?: string;
  @Input() dataSetDesc?: string;

  workflowIdx: { [key: string]: Workflow };
  @ViewChild('workflow', { static: true }) workflowColumnTmpl: TemplateRef<any>;
  @ViewChild('workflowFooter', { static: false })
  workflowColumnFooterTmpl: TemplateRef<any>;
  @ViewChild('cell', { static: true }) columnTmpl: TemplateRef<any>;
  @ViewChild('columnHeader', { static: true }) columnHeaderTmpl: TemplateRef<
    any
  >;

  workflowFilterConfig: WorkflowFilter;
  workflowFilterParams: FilterBuilderParam[];
  workflowFilters: FilterBuilderFilter[];
  filterTypes = [];

  fieldSettingsForm: UntypedFormGroup;

  hasPreviousSystemData=false
  selectedColumnSettingsWorkflowId: string | null = null;
  selectedColumnSettingsField: any | null = null;
  columnSettingsTopOffsetPx = 0;
  isColumnSettingsOpen = false;

  columnOptions: DropdownOption[] = [];
  @Input() staticFields?: DataSetField[];
  columns: TableColumn[];
  rows: any[];
  cellDropdownEntities: any[] = [];
  workflowDisplayNameResolver = (
    workflowId?: string | null,
    fallback = 'Select Workflow'
  ) => this.getWorkflowDisplayName(workflowId, fallback);
  private workflowFilterParamsCache: {
    [workflowId: string]: FilterBuilderParam[];
  } = {};
  private workflowRowKeys: string[] = [];
  resultColumns: CommonTableColumn[];
  resultRows: any[];
  aggregatedResultRows: { [key: string]: any[] };
  aggregatedResultColumns: { [key: string]: CommonTableColumn[] };
  executingTest = false;
  filters: { [key: string]: any[] } = {};

  workflowFilterIndex: { [key: string]: WorkflowFilter };
  get aggResultKeys() {
    if (this.aggregatedResultRows) {
      return Object.keys(this.aggregatedResultRows);
    }
    return null;
  }

  get isNoData() {
    return !this.dataSet || this.dataSet.workflowIds.length === 0;
  }

  get hasFewData() {
    const validWorkflowIds = this.dataSet?.workflowIds?.filter(w => w !== '') || [];
    return validWorkflowIds.length > 0 && validWorkflowIds.length <= 2;
  }

  constructor(    private _workflowSvc: WorkflowService,

    public _context: WorkflowContextService,

    private _route: ActivatedRoute,

    private _router: Router,
    private _toastr :ToastrService,
    private _ref: ChangeDetectorRef,
    private _securitySvc:SecurityService,
    private _reportSvc: ReportService

) {}

ngOnInit(): void {

  this.hasPreviousSystemData = this._context.hasPreviousSystemData;

  this.form = new UntypedFormGroup({
    fieldOrder: new UntypedFormGroup({}),
    workflows: new UntypedFormGroup({}),
    dataSetName: new UntypedFormControl('', Validators.required),
    dataSetDesc: new UntypedFormControl('', Validators.nullValidator),
    dataSetType: new UntypedFormControl('', Validators.nullValidator),
    dataSetOutput: new UntypedFormControl('', Validators.nullValidator)
  });

  this.filterInputForm = new UntypedFormGroup({
    field: new UntypedFormControl('', Validators.required),
    label: new UntypedFormControl('', Validators.nullValidator),
    isRequired: new UntypedFormControl('', Validators.nullValidator),
    searchField: new UntypedFormControl('', Validators.nullValidator)
  });

  this.fieldSettingsForm = new UntypedFormGroup({
    fieldName: new UntypedFormControl('', Validators.required),
    fieldHeader: new UntypedFormControl('', Validators.required),
    fieldDataType: new UntypedFormControl('', Validators.required),
    fieldIsParcelNumber: new UntypedFormControl('', Validators.nullValidator),
    fieldIsPermitNumber: new UntypedFormControl('', Validators.nullValidator),
    fieldOutputFormula: new UntypedFormControl('', Validators.nullValidator),
    fieldConditionalOutput: new UntypedFormControl('', Validators.nullValidator)
  });

  this.mappingForm = new UntypedFormGroup({
    columnEntity: new UntypedFormControl('', Validators.required)
  });

  this._securitySvc.isDeveloper().subscribe(result => {
    this.isDeveloper = result;
  });

  this._securitySvc.isSystemAdministrator().subscribe(result => {
    this.isSystemAdmin = result;
  });

  // workflows
  const workflowSource: Observable<Workflow[]> = this.getAvailableWorkflows
    ? this.getAvailableWorkflows()
    : this._workflowSvc.getWorkflows(
        this._context.client,
        false,
        false,
        [
          WorkflowType.ContractorRegistration,
          WorkflowType.Renewable,
          WorkflowType.ContractorRenewal,
          WorkflowType.Permit,
          WorkflowType.Other,
          WorkflowType.MobileInspection
        ]
      );

  workflowSource.subscribe(workflows => {
    this.workflowIdx = {};

    workflows.forEach(w => {
      this.workflowIdx[w.id] = w;
    });

    if (this.hasPreviousSystemData) {
      this.workflowIdx[this._context.previousSystemDataWorkflowId] = null;
    }

    this.availbleWorkflows = workflows;
    this.availableWorkflows = workflows;
    this.refreshGrid();
  });

  // ✅ DATASET LOAD (NO ROUTE PARAMS)
  const dataSetId: string = this.dataSetId || this.dataSet?.id;

  if (!dataSetId || dataSetId === Utilities.EMPTY_GUID) {
    // NEW DATASET
    const ds = new DataSet();
    ds.dataSetConfig = new WorkflowApplicationReportDataSet();
    ds.clientId = this._context.client.id;
    ds.dataSetConfig.clientIds = [this._context.client.id];

    this.initializeDataSet(ds);
  } else {
    // EXISTING DATASET
    this._workflowSvc.getDataSet(dataSetId).subscribe(ds => {
      this.initializeDataSet(ds);
    });
  }
}
private initializeDataSet(ds: DataSet) {
  this.workflowEntities = {};

  if (!ds.filterConfig) {
    ds.filterConfig = new FilterConfig({ fields: [] });
  }

  this.allowFiltering = (ds.filterConfig.fields || []).length > 0;

  this.ds = ds;
  this.dataSet = ds.dataSetConfig;
  this.ensureDataSetConfigDefaults();

  // dataset name
  if (this.dataSetName && !ds.id) {
    this.ds.name = this.dataSetName;
    this.ds.description=this.dataSetDesc
  }

  if (ds.name) {
    this.form.controls['dataSetName'].setValue(ds.name);

  } else if (this.dataSetName) {
    this.form.controls['dataSetName'].setValue(this.dataSetName);

  }
  if (ds.description) {
    this.form.controls['dataSetDesc'].setValue(ds.description);

  } else if (this.dataSetDesc) {
    this.form.controls['dataSetDesc'].setValue(this.dataSetDesc);

  }
  if (ds.description) {
    this.form.controls['dataSetDesc'].setValue(ds.description);

  } else if (this.dataSetDesc) {
    this.form.controls['dataSetDesc'].setValue(this.dataSetDesc);

  }


  // static filters
  if (
    ds.filterConfig?.staticFilterInput?.length > 0 &&
    (!this.staticFilters || this.staticFilters.length === 0)
  ) {
    const groupedFilters: { [key: string]: ItemSearchOptionField } = {};
    ds.filterConfig.staticFilterInput.forEach(option => {
      if (!groupedFilters[option.title]) {
        groupedFilters[option.title] = {
          title: option.title,
          options: []
        };
      }
      groupedFilters[option.title].options.push(option);
    });
    this.staticFilters = Object.values(groupedFilters);
  }

  // remove bad fields
  this.dataSet.fields = this.dataSet.fields.filter(f => f.name);

  // merge static fields
  if (this.staticFields?.length) {
    this.staticFields.forEach(staticField => {
      const exists = this.dataSet.fields.find(f => f.name === staticField.name);
      if (!exists) {
        this.dataSet.fields.push(staticField);
      }
    });
  }

  // ✅ SORTING LOGIC (UNCHANGED)
  if (this.dataSet.fieldOrder.length === 0) {
    const nonStaticField = this.staticFields?.find(f => f.isStatic === false);

    if (nonStaticField) {
      (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
        'field0',
        new UntypedFormControl(nonStaticField.name, Validators.required)
      );

      (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
        'order0',
        new UntypedFormControl('', Validators.required)
      );

      this.dataSet.fieldOrder.push(
        new ReportDataSetOrder({
          ordinal: 0,
          fieldName: nonStaticField.name
        })
      );

      this.buildSortOrderUI();
    } else {
      this.addSortOrder();
    }
  } else {
    this.buildSortOrderUI();

    if (this.dataSet.workflowIds?.length > 0) {
      const workflowGroup = this.form.controls['workflows'] as UntypedFormGroup;

      this.dataSet.workflowIds.forEach((id, idx) => {
        workflowGroup.addControl(
          idx.toString(),
          new UntypedFormControl(id, Validators.required)
        );
      });

      this.workflowFilterIndex = {};
      this.dataSet.workflowFilters.forEach(f => {
        this.workflowFilterIndex[f.workflowId] = f;
      });
    }
  }

  this.refreshColumnOptions();
  this.refreshGrid();

  this.canPublish = this.canTest();
  this.buildAggregateConditionSources();
  this.initAggregateRows();
  this.buildOutputFormulaConditionSources();

  this.form.valueChanges.subscribe(() => {
    this.canPublish = this.canTest();
    this._ref.detectChanges();
  });

  this._ref.detectChanges();
}

ngOnChanges(changes: SimpleChanges) {
  if (!this.form) {
    return;
  }

  if ((changes['dataSetId'] && this.dataSetId) || (changes['dataSet'] && this.dataSet)) {
    const dataSetId = this.dataSetId || this.dataSet?.id;

    if (dataSetId && dataSetId !== Utilities.EMPTY_GUID) {
      this._workflowSvc.getDataSet(dataSetId).subscribe(ds => {
        this.initializeDataSet(ds);
      });
      return;
    }

    if (this.dataSet && !this.dataSetId) {
      const ds = new DataSet();
      ds.dataSetConfig = this.dataSet;
      ds.clientId = this._context.client.id;

      this.initializeDataSet(ds);
    }
  }
}

private ensureDataSetConfigDefaults() {
  if (!this.dataSet) {
    return;
  }

  if (!Array.isArray(this.dataSet.fields)) {
    this.dataSet.fields = [];
  }

  if (!Array.isArray(this.dataSet.workflowIds)) {
    this.dataSet.workflowIds = [];
  }

  if (!Array.isArray(this.dataSet.workflowFilters)) {
    this.dataSet.workflowFilters = [];
  }

  this.ensureWorkflowFiltersAligned();
}

private createRowKey(): string {
  return `workflow_row_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

private syncWorkflowRowKeys() {
  const workflowIds = this.dataSet?.workflowIds || [];

  while (this.workflowRowKeys.length < workflowIds.length) {
    this.workflowRowKeys.push(this.createRowKey());
  }

  if (this.workflowRowKeys.length > workflowIds.length) {
    this.workflowRowKeys = this.workflowRowKeys.slice(0, workflowIds.length);
  }
}

private createWorkflowFilterConfig(workflowId?: string | null): WorkflowFilter {
  const workflowFilter = new WorkflowFilter();
  workflowFilter.workflowId = workflowId || '';
  workflowFilter.filtersList = [];
  return workflowFilter;
}

private cloneWorkflowFilterConfig(
  workflowFilter: WorkflowFilter | null | undefined,
  workflowId?: string | null
): WorkflowFilter {
  const clonedWorkflowFilter = new WorkflowFilter();
  clonedWorkflowFilter.workflowId = workflowId || workflowFilter?.workflowId || '';
  clonedWorkflowFilter.filtersList = (workflowFilter?.filtersList || []).map(
    filter => new ItemSearchOptionFieldOption({ ...filter })
  );
  return clonedWorkflowFilter;
}

private ensureWorkflowFiltersAligned() {
  const workflowIds = this.dataSet?.workflowIds || [];
  const existingWorkflowFilters = this.dataSet?.workflowFilters || [];
  const workflowFilterQueue: { [workflowId: string]: WorkflowFilter[] } = {};

  existingWorkflowFilters.forEach(filter => {
    const workflowId = filter?.workflowId || '';

    if (!workflowFilterQueue[workflowId]) {
      workflowFilterQueue[workflowId] = [];
    }

    if (!Array.isArray(filter.filtersList)) {
      filter.filtersList = [];
    }

    workflowFilterQueue[workflowId].push(filter);
  });

  this.dataSet.workflowFilters = workflowIds.map(workflowId => {
    const nextFilter = (workflowFilterQueue[workflowId || ''] || []).shift();

    if (nextFilter) {
      nextFilter.workflowId = workflowId || '';
      return nextFilter;
    }

    return this.createWorkflowFilterConfig(workflowId);
  });
}

private getWorkflowFilterConfigAtIndex(index: number): WorkflowFilter {
  const workflowId = this.dataSet?.workflowIds?.[index] || '';

  if (!Array.isArray(this.dataSet.workflowFilters)) {
    this.dataSet.workflowFilters = [];
  }

  while (this.dataSet.workflowFilters.length <= index) {
    const nextWorkflowId =
      this.dataSet.workflowIds[this.dataSet.workflowFilters.length] || '';
    this.dataSet.workflowFilters.push(
      this.createWorkflowFilterConfig(nextWorkflowId)
    );
  }

  const workflowFilter =
    this.dataSet.workflowFilters[index] ||
    this.createWorkflowFilterConfig(workflowId);

  workflowFilter.workflowId = workflowId;

  if (!Array.isArray(workflowFilter.filtersList)) {
    workflowFilter.filtersList = [];
  }

  this.dataSet.workflowFilters[index] = workflowFilter;

  return workflowFilter;
}

private setWorkflowFilterConfigAtIndex(
  index: number,
  workflowFilter: WorkflowFilter | null | undefined
) {
  const workflowId = this.dataSet?.workflowIds?.[index] || '';

  if (!Array.isArray(this.dataSet.workflowFilters)) {
    this.dataSet.workflowFilters = [];
  }

  while (this.dataSet.workflowFilters.length <= index) {
    this.dataSet.workflowFilters.push(this.createWorkflowFilterConfig());
  }

  this.dataSet.workflowFilters[index] = this.cloneWorkflowFilterConfig(
    workflowFilter,
    workflowId
  );
}

private buildFiltersFromWorkflowConfig(
  workflowFilter: WorkflowFilter | null | undefined,
  filterParams: FilterBuilderParam[]
): FilterBuilderFilter[] {
  if (!workflowFilter?.filtersList?.length || !filterParams?.length) {
    return [];
  }

  return workflowFilter.filtersList
    .map(filterItem => {
      let value = null;
      let valueString = null;

      if (filterItem.searchText && filterItem.searchText.indexOf('{') > -1) {
        value = JSON.parse(filterItem.searchText);
      } else if (filterItem.strOperator == 'in' && filterItem.searchText) {
        value = filterItem.searchText.split(',');
      } else {
        valueString = filterItem.searchText;
      }

      const filterParam = filterParams.find(
        param => param.name === filterItem.title
      );

      if (!filterParam) {
        return null;
      }

      return new FilterBuilderFilter({
        param: filterParam,
        value: valueString,
        queryType: filterItem.strOperator,
        customValue: value,
        inputType: filterItem.inputType,
        dataEntityTypeCode: filterItem.dataEntityTypeCode,
        paramId: filterParam.id
      });
    })
    .filter(filter => filter !== null);
}

private buildWorkflowFilterList(filtersOutput: any): ItemSearchOptionFieldOption[] {
  const filterKeys = Object.keys(filtersOutput || {});

  return filterKeys.flatMap(key =>
    (filtersOutput[key] || []).map(
      filter =>
        new ItemSearchOptionFieldOption({
          strOperator: filter.type,
          title: filter.id,
          filterText: filter.value,
          searchText: filter.value,
          inputType: filter.inputType,
          dataEntityTypeCode: filter.dataEntityTypeCode
        })
    )
  );
}

private createWorkflowFilterConfigFromFilters(
  filters: FilterBuilderFilter[] | null | undefined,
  workflowId: string
): WorkflowFilter {
  const workflowFilter = this.createWorkflowFilterConfig(workflowId);

  workflowFilter.filtersList = (filters || []).map(filter => {
    let value = filter.value;

    if (
      filter.queryType === 'range' &&
      (filter.value === 'custom' ||
        filter.param?.inputType === 'text' ||
        filter.param?.inputType === 'number') &&
      filter.customValue &&
      filter.customValue.start &&
      filter.customValue.end
    ) {
      value = JSON.stringify(filter.customValue);
    } else if (filter.queryType === 'in' && Array.isArray(filter.customValue)) {
      value = filter.customValue.join(',');
    }

    return new ItemSearchOptionFieldOption({
      strOperator: filter.queryType,
      title: filter.paramId || filter.param?.id,
      filterText: value,
      searchText: value,
      inputType: filter.inputType || filter.param?.inputType,
      dataEntityTypeCode: filter.dataEntityTypeCode
    });
  });

  return workflowFilter;
}

private getCachedRowFilters(row: any): FilterBuilderFilter[] {
  if (!row?.filterBuilderId || !row?.filterParams?.length) {
    return [];
  }

  try {
    const stringData = localStorage.getItem(
      `filter-builder-${row.filterBuilderId}`
    );

    if (!stringData) {
      return [];
    }

    return (JSON.parse(stringData) || [])
      .map((filter: FilterBuilderFilterFlat) => {
        const param = (row.filterParams || []).find(
          filterParam => filterParam.id === filter.paramId
        );

        if (!param) {
          return null;
        }

        return FilterBuilderFilter.unflatten({
          ...filter,
          param
        });
      })
      .filter(filter => !!filter);
  } catch {
    return [];
  }
}

private getCopySourceRow(workflowId: string, excludedRowKey?: string): any | null {
  return (
    (this.rows || []).find(
      row => row.rowKey !== excludedRowKey && row.workflowId === workflowId
    ) || null
  );
}

private hasWorkflowOccurrence(
  workflowId: string | null | undefined,
  excludedIndex?: number
): boolean {
  if (!workflowId) {
    return false;
  }

  return (this.dataSet?.workflowIds || []).some(
    (id, index) => index !== excludedIndex && id === workflowId
  );
}

private attachWorkflowNames(): void {
  (this.rows || []).forEach(row => {
    row.workflow = this.getWorkflowDisplayName(row.workflowId, '');
  });
}

getWorkflowDisplayName(
  workflowId?: string | null,
  fallback = 'Select Workflow'
): string {
  if (!workflowId) {
    return fallback;
  }

  if (workflowId === this._context.previousSystemDataWorkflowId) {
    return 'Previous System Data';
  }

  if (workflowId === this.ALL_WORKFLOWS_ID) {
    return 'All Workflows';
  }

  const normalizedWorkflowId = workflowId.toLowerCase();
  const workflow = (this.availableWorkflows || []).find((w: any) => {
    const candidateIds = [w?.id, w?.versionId, w?.workflowId, w?.version?.id, w?.version?.workflowId]
      .filter(Boolean)
      .map((value: string) => value.toLowerCase());

    return candidateIds.includes(normalizedWorkflowId);
  });

  return workflow?.name || workflow?.version?.name || workflowId || fallback;
}

private pruneWorkflowState(workflowIds: string[]) {
  const validWorkflowIds = new Set((workflowIds || []).filter(Boolean));

  Object.keys(this.workflowFilterParamsCache).forEach(workflowId => {
    if (!validWorkflowIds.has(workflowId)) {
      delete this.workflowFilterParamsCache[workflowId];
    }
  });
}

private createFilterBuilderId(rowKey: string, workflowId?: string | null): string {
  const workflowKey = workflowId || 'workflow';
  return `dataSetFilters_${workflowKey}_${rowKey}`;
}

private clearWorkflowArtifacts(workflowId?: string | null) {
  if (!workflowId) {
    return;
  }

  delete this.workflowFilterParamsCache[workflowId];

  (this.dataSet?.fields || []).forEach((field: DataSetField) => {
    field.mappings = (field.mappings || []).filter(
      mapping => mapping.workflowId !== workflowId
    );
  });
}

addWorkflow() {
  this.ensureDataSetConfigDefaults();
  this.workflowRowKeys.push(this.createRowKey());
  this.dataSet.workflowIds.push('');
  this.dataSet.workflowFilters.push(this.createWorkflowFilterConfig());
  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

deleteWorkflow(index: number) {
  const workflowId = this.dataSet.workflowIds[index];

  this.workflowRowKeys.splice(index, 1);
  this.dataSet.workflowIds.splice(index, 1);
  this.dataSet.workflowFilters.splice(index, 1);

  if (!this.hasWorkflowOccurrence(workflowId)) {
    this.clearWorkflowArtifacts(workflowId);
  }

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

selectWorkflow(index: number, workflow: Workflow) {
  const workflowId = workflow.id;
  const currentRow = this.rows[index];
  const copySourceRow = this.getCopySourceRow(workflowId, currentRow?.rowKey);
  const copiedFilterParams =
    copySourceRow?.filterParams || this.workflowFilterParamsCache[workflowId] || null;
  const copiedFilters = this.getCachedRowFilters(copySourceRow);
  const copiedFilterConfig = this.cloneWorkflowFilterConfig(
    copySourceRow?.workflowFilterConfig?.filtersList?.length
      ? copySourceRow.workflowFilterConfig
      : this.createWorkflowFilterConfigFromFilters(
          copiedFilters.length ? copiedFilters : copySourceRow?.filters || [],
          workflowId
        ),
    workflowId
  );
  const previousWorkflowId = currentRow?.workflowId || this.dataSet.workflowIds[index];

  if (copiedFilterParams) {
    this.workflowFilterParamsCache[workflowId] = copiedFilterParams;
  }

  this.dataSet.workflowIds[index] = workflowId;
  this.setWorkflowFilterConfigAtIndex(index, copiedFilterConfig);

  if (
    previousWorkflowId &&
    previousWorkflowId !== workflowId &&
    !this.hasWorkflowOccurrence(previousWorkflowId, index)
  ) {
    this.clearWorkflowArtifacts(previousWorkflowId);
  }

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });

  const selectedRow = this.rows[index];

  if (selectedRow?.workflowId && !selectedRow.filterParams) {
    this.loadRowFilterData(selectedRow);
  }

  this.onWorkflowSelected(workflowId);
}

openColumnSettings() {
  this.openColumnSettingsModal(null);
}

editColumn(column: any) {
  const field = (this.dataSet?.fields || []).find(
    (existingField: DataSetField) => existingField.name === column?.name
  );

  this.openColumnSettingsModal({
    workflowId: null,
    field: field ? { ...field } : null
  });
}

moveColumnLeft(column: any) {
  this.moveColumn(column, -1);
}

moveColumnRight(column: any) {
  this.moveColumn(column, 1);
}

deleteColumn(column: any) {
  const fieldName = column?.name;

  if (!fieldName) {
    return;
  }

  const field = (this.dataSet?.fields || []).find(
    (dataSetField: DataSetField) => dataSetField.name === fieldName
  );

  if (field?.isStatic === true) {
    return;
  }

  this.dataSet.fields = (this.dataSet?.fields || []).filter(
    (field: DataSetField) => field.name !== fieldName
  );

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

reorderColumn(event: {
  column: any;
  targetColumn: any;
  previousIndex: number;
  currentIndex: number;
}) {
  if (!event?.column || !event?.targetColumn) {
    return;
  }

  const fields = this.dataSet?.fields || [];
  const sourceIndex = fields.findIndex(
    (field: DataSetField) => field.name === event.column?.name
  );
  const targetIndex = fields.findIndex(
    (field: DataSetField) => field.name === event.targetColumn?.name
  );

  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) {
    return;
  }

  const [field] = fields.splice(sourceIndex, 1);
  fields.splice(targetIndex, 0, field);

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

handleColumnSave(field: any) {
  this.ensureDataSetConfigDefaults();

  const existingColumnIndex = this.dataSet.fields.findIndex(
    (existingField: DataSetField) =>
      existingField.id === field.id || existingField.name === field.name
  );

  if (existingColumnIndex > -1) {
    this.dataSet.fields[existingColumnIndex] = {
      ...this.dataSet.fields[existingColumnIndex],
      ...field,
      mappings: this.dataSet.fields[existingColumnIndex].mappings || []
    };
  } else {
    this.dataSet.fields.push({
      ...field,
      mappings: field.mappings || []
    });
  }

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

openCellDropdown(row: any, col: any) {
  if (!row.workflowId) {
    this.cellDropdownEntities = [];
    return;
  }

  this._workflowSvc.getWorkflowEntities(row.workflowId).subscribe(entities => {
    this.cellDropdownEntities = entities || [];
  });
}

selectCellEntity(row: any, col: any, entity: any) {
  const templateCode = entity?.templateCode || entity?.name;
  const field = (this.dataSet?.fields || []).find(
    (existingField: DataSetField) => existingField.name === col.name
  );

  if (!templateCode || !row.workflowId || !field) {
    return;
  }

  if (!Array.isArray(field.mappings)) {
    field.mappings = [];
  }

  field.mappings.push({
    workflowId: row.workflowId,
    columnIndex:
      this.dataSet.fields.findIndex(
        (existingField: DataSetField) => existingField.name === field.name
      ) + 1,
    templateCode
  });

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

deleteCellValue(row: any, col: any, index: number) {
  const field = (this.dataSet?.fields || []).find(
    (existingField: DataSetField) => existingField.name === col.name
  );

  if (!field || !row.workflowId) {
    return;
  }

  const mappingsForWorkflow = (field.mappings || []).filter(
    mapping => mapping.workflowId === row.workflowId
  );
  const mappingToRemove = mappingsForWorkflow[index];

  if (!mappingToRemove) {
    return;
  }

  field.mappings = (field.mappings || []).filter(
    mapping => mapping !== mappingToRemove
  );

  this.onDatasetChange({
    fields: this.dataSet.fields,
    workflowIds: this.dataSet.workflowIds,
    workflowFilters: this.dataSet.workflowFilters
  });
}

private loadRowFilterData(row: any) {
  if (!row?.workflowId) {
    row.filterParams = null;
    row.filters = [];
    return;
  }

  const rowIndex = this.rows.findIndex(r => r.rowKey === row.rowKey);
  const workflowFilterConfig =
    rowIndex > -1
      ? this.getWorkflowFilterConfigAtIndex(rowIndex)
      : this.createWorkflowFilterConfig(row.workflowId);
  const cachedFilterParams = this.workflowFilterParamsCache[row.workflowId];

  if (cachedFilterParams) {
    row.filterParams = cachedFilterParams;
    row.workflowFilterConfig = this.cloneWorkflowFilterConfig(
      workflowFilterConfig,
      row.workflowId
    );
    row.filters = this.buildFiltersFromWorkflowConfig(
      workflowFilterConfig,
      cachedFilterParams
    );
    return;
  }

  this.filterWorkflow(row.workflowId, workflowFilterConfig).then(result => {
    const currentRow = this.rows.find(r => r.rowKey === row.rowKey);

    if (!currentRow || currentRow.workflowId !== row.workflowId) {
      return;
    }

    this.workflowFilterParamsCache[row.workflowId] = result.filterParams;
    currentRow.workflowFilterConfig = this.cloneWorkflowFilterConfig(
      workflowFilterConfig,
      currentRow.workflowId
    );
    currentRow.filterParams = result.filterParams;
    currentRow.filters = result.filters;
  });
}

onRowFiltersChange2(e: any, row: any) {
  if (!row?.workflowId) {
    return;
  }

  const rowIndex = this.rows.findIndex(r => r.rowKey === row.rowKey);

  if (rowIndex < 0) {
    return;
  }

  const workflowFilterConfig = this.getWorkflowFilterConfigAtIndex(rowIndex);
  workflowFilterConfig.workflowId = row.workflowId;
  workflowFilterConfig.filtersList = this.buildWorkflowFilterList(e);
  row.workflowFilterConfig = this.cloneWorkflowFilterConfig(
    workflowFilterConfig,
    row.workflowId
  );
  row.filters = this.buildFiltersFromWorkflowConfig(
    workflowFilterConfig,
    row.filterParams || []
  );
  this.setWorkflowFilterConfigAtIndex(rowIndex, workflowFilterConfig);
}

buildColumns() {
  return (this.dataSet?.fields || []).map(f => ({
    id: f.id,
    name: f.name,
    resultHeader: f.resultHeader,
    dataType: f.dataType,
    mappings: f.mappings || [],
    outputFormula: f.outputFormula || null,
    conditionalOutput: f.conditionalOutput || false,
    isStatic: f.isStatic === true
  }));
}

buildRows() {
  const fields = this.dataSet?.fields || [];
  const workflowIds = this.dataSet?.workflowIds || [];
  const previousRowsByRowKey: { [rowKey: string]: any } = {};

  this.syncWorkflowRowKeys();
  this.pruneWorkflowState(workflowIds);

  (this.rows || []).forEach(row => {
    if (row?.rowKey) {
      previousRowsByRowKey[row.rowKey] = row;
    }
  });

  return workflowIds.map((workflowId: string, index: number) => {
    const rowKey = this.workflowRowKeys[index];
    const previousRow = previousRowsByRowKey[rowKey];
    const workflowFilterConfig = this.cloneWorkflowFilterConfig(
      this.getWorkflowFilterConfigAtIndex(index),
      workflowId
    );
    const row = previousRow || {
      rowKey,
      workflow: '',
      workflowId
    };
    const workflowChanged = row.workflowId !== workflowId;

    row.rowKey = rowKey;
    row.workflowId = workflowId;
    row.workflowFilterConfig = workflowFilterConfig;
    row.filterBuilderId =
      !row.filterBuilderId || workflowChanged
        ? this.createFilterBuilderId(row.rowKey, workflowId)
        : row.filterBuilderId;

    fields.forEach((field: DataSetField) => {
      row[field.name] = (field.mappings || [])
        .filter(mapping => mapping.workflowId === workflowId)
        .map(mapping => mapping.templateCode);
    });

    if (!workflowId) {
      row.filterParams = null;
      row.filters = [];
      return row;
    }

    const cachedFilterParams =
      this.workflowFilterParamsCache[workflowId] || previousRow?.filterParams || null;
    const cachedRowFilters = this.getCachedRowFilters(previousRow);

    row.filterParams = cachedFilterParams;
    row.filters =
      cachedRowFilters.length && !workflowChanged
        ? cachedRowFilters
        : this.buildFiltersFromWorkflowConfig(
            workflowFilterConfig,
            cachedFilterParams || []
          );

    return row;
  });
}

refreshGrid() {
  if (!this.dataSet) {
    this.columns = [];
    this.rows = [];
    return;
  }

  this.columns = this.buildColumns();
  this.rows = this.buildRows();
  this.attachWorkflowNames();

  this.rows.forEach(row => {
    if (row.workflowId && !row.filterParams) {
      this.loadRowFilterData(row);
    }
  });
}

private refreshColumnOptions() {
  this.columnOptions = (this.dataSet?.fields || [])
    .filter(field => !!field?.name)
    .map(field => ({
      label: field.name,
      value: field.name
    }));
}

private syncFilterFieldsWithColumns() {
  if (!this.ds?.filterConfig) {
    return;
  }

  const fieldNames = new Set((this.dataSet?.fields || []).map(f => f.name));
  this.ds.filterConfig.fields = (this.ds.filterConfig.fields || []).filter(
    field => field?.name && fieldNames.has(field.name)
  );
}

private normalizeFilterField(filter: any) {
  const dsField = (this.dataSet?.fields || []).find(
    field => field.name === filter?.name
  );

  return {
    ...filter,
    dataType: dsField?.dataType ?? filter?.dataType,
    requireInput: filter?.requireInput ?? filter?.required ?? false,
    searchFields: filter?.searchFields || [],
    mappings: filter?.mappings || [],
    showListForSelection: filter?.showListForSelection ?? false,
    allowListSelection: filter?.allowListSelection ?? false,
    isParcelNumber: filter?.isParcelNumber ?? false,
    isPermitNumber: filter?.isPermitNumber ?? false
  };
}


// filter menu config
 allowFilteringChanged(e) {
    this.allowFiltering = e;

    if (!e) {
      this.ds.filterConfig.fields = [];
    }
  }
  onSaveFilterInput(filter: any) {
    if (!this.ds.filterConfig) {
      this.ds.filterConfig = new FilterConfig({ fields: [] });
    }
    const normalizedFilter = this.normalizeFilterField(filter);
    const existing = this.ds.filterConfig.fields.find(
      f => f.name === normalizedFilter.name
    );
    if (!existing) {
      this.ds.filterConfig.fields.push(normalizedFilter);
    } else {
      const idx = this.ds.filterConfig.fields.indexOf(existing);
      this.ds.filterConfig.fields[idx] = normalizedFilter;
    }
  }
  saveFilter(event: any) {
    const { filter, index } = event;
    if (!this.ds.filterConfig) {
      this.ds.filterConfig = new FilterConfig({ fields: [] });
    }
    const normalizedFilter = this.normalizeFilterField(filter);
    if (index > -1) {
      this.ds.filterConfig.fields = this.ds.filterConfig.fields.map((f, i) =>
        i === index ? normalizedFilter : f
      );
    } else {
      this.ds.filterConfig.fields = [
        ...this.ds.filterConfig.fields,
        normalizedFilter
      ];
    }
  }
  deleteFilter(row: any) {
    this.ds.filterConfig.fields =
      this.ds.filterConfig.fields.filter(
        f => f.name !== row.name
      );
  }
  // sorting config
  addSortOrder() {
    if (!this.dataSet) {
      this.dataSet = new WorkflowApplicationReportDataSet();
    }

    if (!this.dataSet.fieldOrder) {
      this.dataSet.fieldOrder = [];
    }

    const index = this.dataSet.fieldOrder.length;

    (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
      'field' + index,
      new UntypedFormControl('', Validators.required)
    );

    (<UntypedFormGroup>this.form.controls['fieldOrder']).addControl(
      'order' + index,
      new UntypedFormControl('', Validators.required)
    );

    this.dataSet.fieldOrder.push(
      new ReportDataSetOrder({ ordinal: index, direction: '' as any })
    );
    this.buildSortOrderUI();
  }
  @Input() showSortingConfiguration: boolean = true;








  sortFieldOrder() {
    this.dataSet.fieldOrder.sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
  }
  getFieldLabel(fieldName: string) {
    const fields = this.dataSet?.fields || [];
    const field = fields.find(f => f.name === fieldName);

    return field ? field.name : fieldName;
  }

  buildSortOrderUI() {
    const existingFieldOrderGroup = this.form.get('fieldOrder') as FormGroup | null;
    const previousOrderValues = this.dataSet.fieldOrder.map((_, idx) =>
      existingFieldOrderGroup?.controls['order' + idx]?.value
    );
    // Added by amisha on 06/29/2026 to preserve saved direction values when rebuilding sort controls for existing datasets.
    // Reason: edit-mode reloads were clearing persisted ascending/descending selections before the next save cycle.
    const shouldResetUnselectedDirections =
      this.showSortingConfiguration && !this.ds?.id;

    this.form.removeControl('fieldOrder');

    this.sortFieldOrder();

    // if (this.showSortingConfiguration) {
    //   this.dataSet.fieldOrder.forEach((fieldOrder, idx) => {
    //     const previousValue = previousOrderValues[idx];
    //     const wasDirectionExplicitlySelected =
    //       previousValue === SortDirection.Ascending ||
    //       previousValue === SortDirection.Descending;

    //     if (
    //       fieldOrder &&
    //       !wasDirectionExplicitlySelected &&
    //       (
    //         fieldOrder.direction === null ||
    //         fieldOrder.direction === undefined ||
    //         fieldOrder.direction === SortDirection.Ascending ||
    //         fieldOrder.direction === SortDirection.Descending
    //       )
    //     ) {
    //       fieldOrder.direction = '' as any;
    //     }
    //   });
    // }

    const fg = new UntypedFormGroup({});

    this.dataSet.fieldOrder.forEach((f, idx) => {
        fg.addControl(
        'field' + idx.toString(),
        new UntypedFormControl(f.fieldName || '', Validators.required)
      );
      fg.addControl(
        'order' + idx.toString(),
        new UntypedFormControl(f.direction || '', Validators.required)
      );
    });

    this.form.addControl('fieldOrder', fg);

    this._ref.detectChanges();
  }
  orderChange() {
    let idx = 0;
    this.dataSet.fieldOrder.forEach(fo => {
      fo.ordinal = idx;
      idx++;
    });
    this.buildSortOrderUI();
  }
  // workflow config
  onDatasetChange(data: any) {
    this.dataSet.fields = data.fields;
    this.dataSet.workflowIds = data.workflowIds;
    this.dataSet.workflowFilters = data.workflowFilters || this.dataSet.workflowFilters;
    this.refreshColumnOptions();
    this.syncFilterFieldsWithColumns();
    this.refreshGrid();
  }


  // save data set
  createAggFieldTypes(fieldType: string, aggField: DataSetAggregateField) {
    switch (fieldType) {
      case AggregatedDataSetFieldTypes.calculatedField:
        return new DataSetAggregateCalculatedField(aggField);
      case AggregatedDataSetFieldTypes.groupKeyField:
        return new DataSetAggregateKeyField(aggField);
      case AggregatedDataSetFieldTypes.staticField:
        return new DataSetAggregateStaticField(aggField);
    }
  }

  canTest() {
    const dataSetName = (this.form?.controls['dataSetName']?.value || this.ds?.name || '').trim();
    return (
      this.dataSet &&
      this.dataSet.fields.length !== 0 && // no fields defined
      this.ds &&
      dataSetName !== '' && // name defined
      !this.dataSet.fieldOrder.some(fo => (fo.fieldName || '') === '')
    );
  }
  buildAggregateConditionSources() {
    const fieldSources: ConditionSource[] = this.dataSet.fields.map(f => {
      return {
        name: f.name,
        value: f.name, //f.resultHeader,
        operators: this.buildFieldOperators(f),
        possibleValues: this.buildPossibleFieldValues(f)
      };
    });

    this.conditionSources = fieldSources;
  }

  buildFieldOperators(field: DataSetField): ConditionOperator[] {
    const ops: ConditionOperator[] = [
      OperatorTypes.IS,
      OperatorTypes.EXISTS,
      OperatorTypes.NOT_EXISTS,
      OperatorTypes.IS_NOT,
      OperatorTypes.CONTAINS,
      OperatorTypes.DOES_NOT_CONTAIN
    ];

    if (field.dataType == ReportDataSetFieldDataType.Date) {
      [OperatorTypes.RANGE].forEach(o => {
        ops.push(o);
      });
    }

    if (field.dataType == ReportDataSetFieldDataType.String) {
      ops.push(OperatorTypes.DOES_NOT_CONTAIN);
    }

    return ops;
  }

  buildPossibleFieldValues(field: DataSetField): ConditionValue[] {
    if (field.dataType == ReportDataSetFieldDataType.Date) {
      const dateInputs = this.ds.filterConfig.fields.filter(
        f => f.dataType == ReportDataSetFieldDataType.Date
      );

      return dateInputs.map(di => {
        return {
          name: `input:${di.name}`,
          value: `input:${di.name}`
        };
      });
    }

    return null;
  }
  initAggregateRows() {
    if (this.dataSet.aggregatedDataSets) {
      for (
        let aggIdx = 0;
        aggIdx < this.dataSet.aggregatedDataSets.length;
        aggIdx++
      ) {
        const aggDS = this.dataSet.aggregatedDataSets[aggIdx];

        for (let aggRowIdx = 0; aggRowIdx < aggDS.rows.length; aggRowIdx++) {
          let aggRow = aggDS.rows[aggRowIdx];

          aggRow = this.createRowType(aggRow, aggRow.type);

          for (let fieldIdx = 0; fieldIdx < aggRow.fields.length; fieldIdx++) {
            let aggField = aggRow.fields[fieldIdx];

            aggField = this.createAggFieldTypes(aggField.type, aggField);

            if (aggField) {
              aggField.init();
            }
            aggRow.fields[fieldIdx] = aggField;
          }

          aggDS.rows[aggRowIdx] = aggRow;
        }
      }
    }
  }

  createAggRowTypes(rowType: string, aggRow: DataSetAggregateRow) {
    switch (rowType) {
      case AggregatedDataSetRowTypes.groupingRow:
        return new DataSetAggregrateGroupingRow(aggRow);
      case AggregatedDataSetRowTypes.groupingCriteriaRow:
        return new DataSetAggregateGroupedCriteriaRow(aggRow);
    }
  }

  createRowType(
    aggRow: DataSetAggregateRow,
    aggRowType: string
  ): DataSetAggregateRow {
    const newAggRow = this.createAggRowTypes(aggRowType, aggRow);

    if (newAggRow) {
      newAggRow.init();
    }

    return newAggRow;
  }
  private validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  buildOutputFormulaConditionSources() {
    let fieldOptions = {};

    this.dataSet.fields.forEach(f => {
      fieldOptions[f.name] = f;
    });

    let fieldNames = this.dataSet.fields.map(f => f.name);

    this.dataSet.fields.forEach(f => {
      if (f.mappings) {
        f.mappings.forEach(m => {
          if (!fieldOptions[m.templateCode]) {
            fieldOptions[m.templateCode] = f;
          }
        });
      }
    });

    const fieldOptKeys = Object.keys(fieldOptions);

    const fieldSources: ConditionSource[] = fieldOptKeys.map(k => {
      return {
        name: k,
        value: k,
        operators: this.buildFieldOperators(fieldOptions[k]),
        possibleValues: this.buildPossibleFieldValues(fieldOptions[k])
      };
    });

    this.outputFormulaConditionSources = fieldSources;
  }


  private syncDataSetMetaFromForm() {
    if (!this.ds || !this.form) {
      return;
    }

    const dataSetName = (this.form.controls['dataSetName']?.value || '').trim();
    const dataSetDesc = this.form.controls['dataSetDesc']?.value || '';
    const dataSetType =
      this.form.controls['dataSetType']?.value ||
      this.ds.dataSetConfig?.type ||
      'workflow-application-dataset';
    const dataSetOutput =
      this.form.controls['dataSetOutput']?.value ??
      this.ds.dataSetConfig?.outputDataSet ??
      '';

    this.ds.name = dataSetName;
    this.ds.description = dataSetDesc;

    if (this.ds.dataSetConfig) {
      this.ds.dataSetConfig.type = dataSetType;
      this.ds.dataSetConfig.outputDataSet = dataSetOutput;
    }

    this.normalizeFieldOrderForRequest();
  }
  private normalizeFieldOrderForRequest() {
    if (!this.dataSet?.fieldOrder) {
      return;
    }

    this.dataSet.fieldOrder = this.dataSet.fieldOrder.map((fieldOrder, index) => {
      const normalizedDirection =
        Number(fieldOrder.direction) === SortDirection.Descending
          ? SortDirection.Descending
          : SortDirection.Ascending;

      return new ReportDataSetOrder({
        ...fieldOrder,
        ordinal: index,
        direction: normalizedDirection
      });
    });
  }
  private buildSerializedDataSetConfig(): any {
    return {
      ...this.dataSet,
      fieldOrder: (this.dataSet?.fieldOrder || []).map(fieldOrder => ({
        ...fieldOrder,
        direction:
          fieldOrder.direction !== null && fieldOrder.direction !== undefined
            ? String(fieldOrder.direction)
            : ''
      })),
      workflowFilters: (this.dataSet?.workflowFilters || [])
        .map(filter => ({
          ...filter,
          filtersList: (filter.filtersList || [])
            .filter(filterItem => {
              const hasValue =
                (filterItem?.filterText || '') !== '' ||
                (filterItem?.searchText || '') !== '' ||
                (filterItem?.strOperator || '') === 'exists' ||
                (filterItem?.strOperator || '') === 'not exists';

              return hasValue;
            })
            .map(filterItem => ({
              ...filterItem
            }))
        }))
        .filter(filter => (filter.filtersList || []).length > 0)
    };
  }
  private buildSerializedDataSetPayload(): any {
    return {
      ...this.ds,
      dataSetConfig: this.buildSerializedDataSetConfig()
    };
  }
  private buildTestDataSetConfig(): any {
    return {
      ...this.dataSet,
      fields: (this.dataSet?.fields || []).map(field => {
        const {
          isStatic,
          isAvailableColumn,
          ...rest
        } = field as any;

        return {
          ...rest,
          mappings: field.mappings || []
        };
      }),
      fieldOrder: (this.dataSet?.fieldOrder || []).map(fieldOrder => ({
        ...fieldOrder
      })),
      workflowFilters: (this.dataSet?.workflowFilters || []).map(filter => ({
        ...filter
      }))
    };
  }
  private buildTestFilterConfig(): any {
    return {
      ...this.ds?.filterConfig,
      fields: (this.ds?.filterConfig?.fields || []).map(field => {
        const {
          isStatic,
          isAvailableColumn,
          ...rest
        } = field as any;

        return {
          ...rest
        };
      })
    };
  }
  private createResultTableColumns(
    columns: Array<{ prop: string; name: string }>
  ): CommonTableColumn[] {
    return columns.map(column => ({
      key: column.prop,
      label: column.name,
      headerType: 'text',
      cellType: 'text'
    }));
  }
  saveDataSet() {
    this.syncDataSetMetaFromForm();
    this.syncFilterFieldsWithColumns();

    if (this.canTest() && this.form.valid) {
      // Apply static filters if provided - convert ItemSearchOptionField[] to ItemSearchOptionFieldOption[]
      if (this.staticFilters && this.staticFilters.length > 0) {
        // Flatten the ItemSearchOptionField structure to ItemSearchOptionFieldOption array for backend
        const flattenedFilters: ItemSearchOptionFieldOption[] = [];
        this.staticFilters.forEach(field => {
          if (field.options && field.options.length > 0) {
            field.options.forEach(option => {
              flattenedFilters.push(option);
            });
          }
        });
        this.ds.filterConfig.staticFilterInput = flattenedFilters;
      }

      this._workflowSvc.saveDataSet(this.buildSerializedDataSetPayload()).subscribe(ds => {
        this.ds = ds;
        this.dataSet = ds.dataSetConfig;
        this.buildAggregateConditionSources();
        this.initAggregateRows();
        this.buildOutputFormulaConditionSources();
        this.openSaveSuccessModal();
      });
    } else {
      this.validateAllFormFields(this.form);
    }
  }
  @ViewChild('publishModal', { static: false }) publishModal: any;

  publishDataSetModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Publish Data Set Confirmation',
    modalSubDescp: 'Are you sure you want to publish the changes to this Data Set?',
    yesNoBtn: true,
    inTime: 300,
    outTime: 200,

  };

  onOpenPublishData() {
    this.publishDataSetModalData = {
      ...this.publishDataSetModalData,
      open: true
    };
  }
  onClosePublishData = () => {
    this.publishDataSetModalData = {
      ...this.publishDataSetModalData,
      open: false
    };
  };
  onPublishDataSet() {
    this.publishDataSetModalData = {
      ...this.publishDataSetModalData,
      open: false
    };


  }
  closeTestResults() {
    this.resultColumns = null;
    this.resultRows = null;
    this.aggregatedResultRows = null;
    this.aggregatedResultColumns = null;
  }
  testDataSet() {
    this.syncDataSetMetaFromForm();
    this.syncFilterFieldsWithColumns();

    let inputValues: ItemSearchOptionFieldOption[] = [];

    if (this.filters) {
      const filterKeys = Object.keys(this.filters);

      const mappedFilters = filterKeys.flatMap(f => {
        return this.filters[f].map(filter => {
          return new ItemSearchOptionFieldOption({
            title: filter.id,
            strOperator: filter.type,
            searchText: filter.value,
            filterText: filter.value,
            inputType: filter.inputType
          });
        });
      });

      inputValues = inputValues.concat(mappedFilters);
    }

    if (!this.ds.filterConfig) {
      this.ds.filterConfig = { fields: [], staticFilterInput: [] };
    }

    if (this.staticFilters && this.staticFilters.length > 0) {
      const staticFilterValues = this.staticFilters.flatMap(field => {
        return field.options || [];
      });
      this.ds.filterConfig.staticFilterInput = staticFilterValues;
    }

    const request = {
      customReport: {
        dataSetConfig: this.buildTestDataSetConfig(),
        filterConfig: this.buildTestFilterConfig()
      },
      filterInput: {
        inputValues: inputValues,
        maxRows: 20
      }
    };

    this.executingTest = true;
    this.resultColumns = null;
    this.resultRows = null;
    this.aggregatedResultRows = null;
    this.aggregatedResultColumns = null;

    this._reportSvc.testDataSet(request).subscribe(
      results => {
        const resultColumns = this.dataSet.fields.map(f => {
          return {
            prop: (f.resultHeader || f.name).toLowerCase(),
            name: f.resultHeader || f.name
          };
        });

        const resultRows = [];

        for (let idx = 0; idx < results.rows.length; idx++) {
          const r = results.rows[idx];
          const result = {};

          result['id'] = r.id;

          Object.keys(r.values).forEach(k => {
            const newKey = k.toLowerCase();
            result[newKey] = r.values[k];
          });

          resultRows.push(result);
        }

        const aggregatedResultRows = {};

        if (results.aggregatedResults) {
          const keys = Object.keys(results.aggregatedResults);
          this.aggregatedResultColumns = {};
          keys.forEach(key => {
            const aggDS = (this.dataSet.aggregatedDataSets || []).find(
              ads => ads.name.toLowerCase() == key.toLowerCase()
            );
            let aggColumns = [];
            if (aggDS) {
              aggColumns = aggDS.rows[0].fields.map(f => {
                return {
                  prop: f.name.toLowerCase(),
                  name: f.headerText || f.name
                };
              });
            } else {
              aggColumns = Object.keys(
                results.aggregatedResults[key][0].values
              ).map(k => {
                return {
                  prop: k.toLowerCase(),
                  name: k
                };
              });
            }

            this.aggregatedResultColumns[key] =
              this.createResultTableColumns(aggColumns);

            const aggResultRows = [];
            const aggRows = results.aggregatedResults[key];

            if (aggRows) {
              for (let aggIdx = 0; aggIdx < aggRows.length; aggIdx++) {
                const r = aggRows[aggIdx];
                const aggResult = {};

                aggResult['id'] = r.id;

                Object.keys(r.values).forEach(k => {
                  const newKey = k.toLowerCase();
                  aggResult[newKey] = r.values[k];
                });

                aggResultRows.push(aggResult);
              }

              aggregatedResultRows[key] = aggResultRows;
            }
          });
        }

        this.aggregatedResultRows = aggregatedResultRows;
        this.executingTest = false;
        this.resultColumns = this.createResultTableColumns(resultColumns);
        this.resultRows = resultRows;
      },
      e => {
        this.executingTest = false;
        if (e instanceof TimeoutError) {
          this._toastr.error('Test took too long');
        } else {
          const errorMsg =
            'Something went wrong while adding the new dataset. Please check your input and try again.';
          this._toastr.error(errorMsg || e.error.exceptionMessage);
        }
      }
    );
  }
  publishDataSet() {
    this.syncDataSetMetaFromForm();

    if (this.canTest()) {
      this._workflowSvc.saveDataSet(this.buildSerializedDataSetPayload()).subscribe(resultDS => {
        this._workflowSvc.publishDataSet(resultDS.id).subscribe(() => {
            this._router.navigate(['../new-dataset'], { relativeTo: this._route });
        });
      });
    }
  }
 // added by ketan 09-03-2026
  keyBoardDropDownIcon = svgs.keyboardArrowDownIcon.name
  selectOrderBy(field: string, idx: number) {

    this.dataSet.fieldOrder[idx].fieldName = field;

    (this.form.get('fieldOrder') as FormGroup)
      .controls['field' + idx]
      .setValue(field);
  }

  selectDirection(value: number, idx: number) {

  const direction : SortDirection = value;

  this.dataSet.fieldOrder[idx].direction = direction;

  (this.form.get('fieldOrder') as FormGroup)
    .controls['order' + idx]
    .setValue(direction);
}
  sortingConfigurationDeleteModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Remove Sorting Column',
    modalSubDescp: 'Are you sure you want to remove this Sorting Column?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  sortingConfigurationDeleteTarget?: ReportDataSetOrder;
  onSortingConfigurationDeleteClick = (template: TemplateRef<any>, fieldOrder: ReportDataSetOrder) => {
    return {
      text: template,
      onClick: () => {
        this.sortingConfigurationDeleteTarget = fieldOrder;
        this.sortingConfigurationDeleteModalData = {
          ...this.sortingConfigurationDeleteModalData,
          open: true
        };
      }
    }
  }

  handleSortingConfigurationDeleteModalAccepted(fieldOrder: ReportDataSetOrder) {
    const idx = this.dataSet.fieldOrder.indexOf(fieldOrder);
    if (idx > -1) {
      this.dataSet.fieldOrder.splice(idx, 1);
      this.buildSortOrderUI();
    }
  }

  handleSortingConfigurationDeleteModalRejected() {
  }
  // ended by ketan 09-03-2026
  saveSuccessModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Data Set Saved',
    modalSubDescp: 'Your data set has been saved successfully.',
    yesNoBtn: false,
    okBtn: true,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'success'
  };

  openSaveSuccessModal() {
    this.saveSuccessModalData = {
      ...this.saveSuccessModalData,
      open: true
    };
  }

  handleSaveSuccessModalOk() {
    this.saveSuccessModalData = {
      ...this.saveSuccessModalData,
      open: false
    };
    this.dataSetSaved.emit(this.ds?.id);
  }

  openColumnSettingsModal(
    request: string | null | { workflowId: string | null; field?: any | null }
  ) {
    const columnRequest =
      typeof request === 'object' && request !== null ? request : null;

    this.selectedColumnSettingsWorkflowId = columnRequest
      ? columnRequest.workflowId
      : (request as string | null);
    this.selectedColumnSettingsField = columnRequest?.field || null;
    this.columnSettingsTopOffsetPx = 0;
    this.isColumnSettingsOpen = true;
    this._ref.detectChanges();

    const scrollModalIntoView = () => {
      const modal = document.querySelector(
        'wm-column-settings .wm-overlay-content'
      ) as HTMLElement | null;
      const scrollContainer = document.querySelector(
        '.reports-content'
      ) as HTMLElement | null;

      if (!modal || !scrollContainer) {
        return false;
      }

      const rect = modal.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const desiredTop = 88;
      const targetScrollTop =
        scrollContainer.scrollTop + (rect.top - containerRect.top) - desiredTop;

      const nextTop = Math.max(targetScrollTop, 0);
      scrollContainer.scrollTop = nextTop;
      scrollContainer.scrollTo?.({
        top: nextTop,
        behavior: 'smooth'
      });

      return true;
    };

    let attempts = 0;
    const tryScroll = () => {
      attempts++;
      const didScroll = scrollModalIntoView();

      if (!didScroll && attempts < 6) {
        requestAnimationFrame(tryScroll);
      }
    };

    requestAnimationFrame(tryScroll);
  }
  handleColumnSettingsSave(field: any) {
    this.handleColumnSave(field);
    this.refreshColumnOptions();
    this.closeColumnSettingsModal();
  }

  closeColumnSettingsModal() {
    this.isColumnSettingsOpen = false;
    this.selectedColumnSettingsWorkflowId = null;
    this.selectedColumnSettingsField = null;
    this.columnSettingsTopOffsetPx = 0;
  }

  private moveColumn(column: any, direction: -1 | 1) {
    const fields = this.dataSet?.fields || [];
    const currentIndex = fields.findIndex(
      (field: DataSetField) => field.name === column?.name
    );
    const targetIndex = currentIndex + direction;

    if (
      currentIndex < 0 ||
      targetIndex < 0 ||
      targetIndex >= fields.length
    ) {
      return;
    }

    const [field] = fields.splice(currentIndex, 1);
    fields.splice(targetIndex, 0, field);

    this.onDatasetChange({
      fields: this.dataSet.fields,
      workflowIds: this.dataSet.workflowIds,
      workflowFilters: this.dataSet.workflowFilters
    });
  }
  onWorkflowSelected(workflowId: string) {
      setTimeout(() => {
        this.filterWorkflow(workflowId);
  this.buildOutputFormulaConditionSources()
      });

    }
    async filterWorkflow(
      workflowId: string,
      workflowFilterConfig?: WorkflowFilter | null
    ): Promise<{
      filterParams: FilterBuilderParam[];
      filters: FilterBuilderFilter[];
    }> {
      this.workflowFilterParams = null;
      this.workflowFilters = null;
      this.workflowFilterConfig = null;
      const filter = this.cloneWorkflowFilterConfig(
        workflowFilterConfig,
        workflowId
      );

      let entityObs = null;

      if (workflowId != this._context.previousSystemDataWorkflowId) {
        if (workflowId !== this.ALL_WORKFLOWS_ID) {
          entityObs = this._workflowSvc.getDraftWorkflowEntities(workflowId);
        } else {
          entityObs = this._workflowSvc.getDataEntities(null, null, true);
        }
      } else {
        const fields = await this._workflowSvc.getPreviousSystemDataFields(
          this._context.client.id
        );

        entityObs = of(
          fields.map(e => {
            if (e.dataType == ReportDataSetFieldDataType.Date) {
              return new DateDataEntity({
                templateCode: e.name,
                label: e.name
              });
            } else {
              return new FreeFormTextDataEntity({
                templateCode: e.name,
                label: e.name
              });
            }
          })
        );
      }

      return await new Promise(resolve => {
        entityObs.subscribe(entities => {
          const filterParams: FilterBuilderParam[] = entities.map(e => {
            return {
              name: e.templateCode,
              id: e.templateCode,
              paramId: e.templateCode,
              inputType: DataSet.resolveInputType(e),
              dataEntityTypeCode: e.Type,
              types: DataSet.resolveTypes(e),
              options: (() => {
                const os = DataSet.resolveOptions(e);
                if (os) {
                  return os.map(o => {
                    return { name: o, value: o };
                  });
                } else {
                  return null;
                }
              })()
            };
          });

          const filters = this.buildFiltersFromWorkflowConfig(filter, filterParams);

          this.workflowFilterConfig = filter;
          this.workflowFilters = filters.filter(f => f);
          this.workflowFilterParams = filterParams;

          resolve({
            filterParams,
            filters: filters.filter(f => f)
          });
        });
      });
    }

}

